import {
  createBrowserRouter,
  RouterProvider
} from "react-router"
import PageTemplate from "./components/PageTemplate"
import Home from "./pages/Home"
import { rootContext } from "./contexts/rootContext"
import { useState } from "react"
import { getTheme } from "./utilities/theme"
import { useMediaQuery } from "@mui/material"
import Blog_Abstraction from "./pages/Blog_Abstraction"
import Buffalo from "./pages/Buffalo"
import Empty from "./pages/Empty"
import { ThemeMode } from "./types"

function App() {
  const [themeMode, setThemeMode] = useState<ThemeMode>("dark")
  const theme = getTheme(themeMode)
  const isScreenTooSmall = useMediaQuery('(max-width:1060px)')
  const isScreenWayTooSmall = useMediaQuery('(max-width:700px)')

  const rootDiv = document.getElementById('root')
  if (rootDiv !== null) {
    if (isScreenTooSmall || isScreenWayTooSmall) {
      rootDiv.style.setProperty('background-color', theme.background)
    } else {
      rootDiv.style.setProperty('background-color', "unset")
    }
  }

  const router = createBrowserRouter([
    {
      path: "/",
      element: (<PageTemplate>
          <Home />
        </PageTemplate>),
    },
    {
      path: "/blog/abstraction",
      element: (<PageTemplate>
          <Blog_Abstraction />
        </PageTemplate>),
    },
    {
      path: "/buffalo",
      element: (<PageTemplate disableHeader disableEdges>
          <Buffalo />
        </PageTemplate>),
    },
    {
      path: "/empty",
      element: (<Empty />),
    },
  ])

  return (
        <rootContext.Provider value={{
          theme,
          themeMode,
          setThemeMode,
          isScreenTooSmall,
          isScreenWayTooSmall
        }}>
          <RouterProvider router={router} />
        </rootContext.Provider>
    )
}

export default App
